import ControlledByMixin from './ControlledByMixin.js'
import CurrencyRate from './CurrencyRate'
import APP from 'src/main.js'
import axiosInstance from 'stores/axiosInstance';

class Event extends ControlledByMixin {

  constructor(rec){
    super(rec)

    // Will be the latest currency
    this._currency_rate = this.constructor.employeeStore.currency_rates[0]
  }
  get controller_name(){
    return 'EventsController'
  }

  fetchCurrencyRate(){
    const currency_date = this.sdate || this.date

    if(currency_date){
      if(this._currency_rate_date && currency_date === this._currency_rate_date){
        return Promise.resolve()
      } else {
        return this.constructor.employeeStore.controllers.CurrencyRatesController.getRow(currency_date).then((res)=>{
          this._currency_rate_date = currency_date
            return this._currency_rate = res
        })
      }
    } else {
      return Promise.resolve()
    }
  }

  // Default behaviour -- Determines that the event should not be matched with an expected event
  get should_be_linked() {
    return false
  }

  fetchOutstandingFees(){
    if (! this.entity_id || !this.sdate || (this.sdate && new Date(this.sdate).getFullYear() < 1900) || this.type !== 'FeePayment') {
      return null
    }

    let thissy = this
    return axiosInstance.get("/outstanding_fee", {
      params: {
        entity_id: thissy.entity_id,
        date: `..${thissy.sdate}`
        }
    }).then((res)=>{
      return res
    }).catch((err)=>{
      throw(err)
    })
  }

  fetchLiableFees(){
    let thissy = this
    return new Promise(function(resolve) {
      if(thissy.type === 'FeePayment' && thissy.sdate && new Date(thissy.sdate).getFullYear() > 1900){
        let q = {
          where: {
            entity_id: thissy.entity_id,
            date: ".." + thissy.sdate
          },
          order: {
            date: 'desc'
          },
          fields: [
            'liable_fee',
            'liable_fixed_fee',
            'liable_perf_fee',
          ]
        }

        return this.constructor.employeeStore.GET_FEES(q).then((res)=>{
          resolve(res)
        })
      } else {
        resolve()
      }
    })
  }

  get issue_fund_group(){
    if (this.issue_fund_group_id) {
      return this.constructor.employeeStore.issue_fund_groups.find(ac => ac.id === this.issue_fund_group_id)
    } else {
      return null
    }
  }

  set issue_fund_group(issue_fund_group){
    if (issue_fund_group){
      this.issue_fund_group_id = issue_fund_group.id
    }
  }
  get controlled(){
    return this.controlled_by ? true : false
  }
  get creator(){
    return this.constructor.employeeStore.users.find(usr => usr.id === this.created_by)
  }
  get creator_name(){
    if(this.creator){
      return this.creator.name
    } else {
      return null
    }
  }
  get account(){
    return this.constructor.employeeStore.accountsById.get(this.account_id)
  }
  get entity_id(){
    return (this.account||{}).entity_id
  }

  get entity(){
    if (this.entity_id == null) {return null}

    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }

  get entity_name(){
    return (this.entity||{name: this.entity_id}).name
  }

  get account_name(){
    if(this.account){
      return this.account.name
    } else {
      return null
    }
  }
  get deposit(){
    return this.constructor.employeeStore.deposits.find(ac => ac.id === this.deposit_id)
  }
  set deposit(deposit){
    if (deposit != null){
      this.deposit_id = deposit.id
    }
  }
  get deposit_name(){
    if(this.deposit){
      return this.deposit.name
    } else {
      return null
    }
  }
  get issue(){
    return this.constructor.employeeStore.issues.find(ac => ac.id === this.issue_id)
  }
  set issue(issue){
    if (issue){
      this.issue_id = issue.id
    }
  }
  get text_type(){
    if(this.text === this.auto_text){
      return 'auto_text'
    } else if(this.text === this.raw_text) {
      return 'raw_text'
    } else if(this.text === this.personal_text) {
      return 'personal_text'
    } else {
      return 'raw_text'
    }
  }
  get issue_name(){
    if(this.issue){
      return this.issue.name
    } else {
      return null
    }
  }
  get text(){
    if(this.personal_text){return this.personal_text}
    if(this.auto_text){return this.auto_text}
    if(this.raw_text){return this.raw_text}
    return null
  }
  get account_crncy(){
    return (this.account||{crncy: 'DKK'}).crncy
  }

  computeLocale(value, crncy){
    if(this.account_crncy === crncy){
      return value
    } else {
      return (value||0)/this._currency_rate.getRate(crncy, this.account_crncy)
    }
  }
  valueLocale(crncy){
    return this.computeLocale(this.value, crncy)
  }
  fractionalLocale(crncy){
    return this.computeLocale(this.fractional_value, crncy)
  }
}

export default Event
